<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_bounce_message_settings_route_page_title')">
    <server-table
      class="text-center groovemail-bounce-message-settings-table"
      ref="serverTable"
      :url="bounceMessageListingUrl"
      tableRef="bounceMessageSettingsTable"
      :slotData="bounceMessageTableSlotData"
      :tableColumns="bounceMessagesTableColumns"
      :tableOptions="bounceMessagesTableOptions"
      :filters="getBounceMessageTypes"
      :selectedFilter="bounceFilterType"
      :bulkOptions="getBulkOptions"
      :buttonViaImport="bounceMessageButtonViaImport"
      bulkActionName="frontend_groovesell_bulk_actions"
      filterName="frontend_groovemail_admin_bounce_message_settings_all_bounces"
      tableTitle="frontend_groovemail_admin_bounce_message_settings_route_page_title"
      addNewBtnText="frontend_groovemail_admin_bounce_message_settings_new_bounce_message"
      uploadFileBtnText="frontend_groovemail_admin_bounce_message_settings_import_bounce_message"
      downloadSampleFileBtnText="frontend_groovemail_admin_block_sample_file"
      @downloadSampleFile="downloadSampleForBounceMessage"
      @onFileChange="onFileChange"
      @addNewData="openBounceMessageModal"
      @filterUpdated="bounceFilterUpdated"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="bounce-message-modal"
      name="bounce-message-modal"
      :title="modalTitle"
      @closed="bounceMessageInitialized()"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_admin_bounce_message_settings_bounce_message')">
          <text-area
            v-if="addModal"
            variant="base"
            v-model="model.bounceMessage"
            :placeholder=" $t('frontend_groovemail_admin_bounce_message_settings_enter_new_bounce_message')"
            rows="5"
          />
          <text-area
            v-else
            variant="base"
            v-model="model.bounceMessage"
            :placeholder="$t('frontend_groovemail_admin_bounce_message_settings_enter_new_bounce_message')"
            rows="5"
          />
          <p
            class="gm-admin-tab__error"
            v-if="this.formSubmitted && !$v.model.bounceMessage.required"
          >
            {{ $t('frontend_groovemail_admin_bounce_message_settings_bounce_message_required') }}
          </p>
          <p
            class="gm-admin-tab__error"
            v-if="this.formSubmitted && !$v.model.bounceMessage.minLength"
          >
            {{
              `${$t(
                'frontend_groovemail_admin_bounce_message_settings_must_have_at_least'
              )} ${$v.model.bounceMessage.$params.minLength.min}  ${$t(
                'frontend_groovemail_admin_bounce_message_settings_characters'
              )}.`
            }}
          </p>
          <p
            class="gm-admin-tab__error"
            v-if="this.formSubmitted && !$v.model.bounceMessage.maxLength"
          >
            {{
              `${$t(
                'frontend_groovemail_admin_bounce_message_settings_must_have_at_most'
              )} ${$v.model.bounceMessage.$params.maxLength.max}  ${$t(
                'frontend_groovemail_admin_bounce_message_settings_characters'
              )}.`
            }}
          </p>
        </gs-field>
        <gs-field :label="$t('frontend_groovemail_admin_bounce_message_settings_bounce_type')">
          <select v-model="model.bounceMessageType">
            <option value="">
              {{ $t('frontend_groovemail_admin_bounce_message_settings_select_bounce_type') }}
            </option>
            <option
              v-for="bounceType in getBounceMessageTypes"
              :key="bounceType.id"
              :value="bounceType.value"
            >
              {{ bounceType.name }}
            </option>
          </select>
          <p
            class="gm-admin-tab__error"
            v-if="this.formSubmitted && !$v.model.bounceMessageType.required"
          >
            {{ $t('frontend_groovemail_admin_bounce_message_settings_bounce_message_type_required') }}
          </p>
        </gs-field>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeBounceMessageModal()">
            {{ $t('frontend_cancel') }}
          </gs-button>
          <gs-button
            variant="primary"
            @click="addModal ? addBounceMessages() : updateBounceMessages()"
          >
            {{ addModal ? $t('frontend_save') : $t('frontend_update') }}
          </gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete Bounce Message modal -->
    <confirm-modal
      :ref="`confirmation-delete-bounce-message`"
      :name="`confirmation-delete-bounce-message`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_bounce_message')"
      @confirm="deleteBounceMessage"
      @close="closeDeleteBounceMessage"
    />

    <!-- Confirmation delete Filter Updated modal -->
    <confirm-modal
      :ref="`confirmation-delete-filter-updated`"
      :name="`confirmation-delete-filter-updated`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="messageContent"
      @confirm="deleteFilterUpdated"
      @close="closeDeleteFilterUpdatedModal"
    />

    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_bounce_message_settings_are_you_sure_import_bounce_messages')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData, putData, deleteData } from '@/utils/apiHelper.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';
import monthsMixin from '@/mixin/monthsMixin.js';
import downloadCsvFile from '@/components/downloadCsvFile.js';

export default {
  middleware: 'auth',

  metaInfo() {
    return {
      title: this.$t(
        'frontend_groovemail_admin_bounce_message_settings_route_page_title'
      ),
    };
  },

  mixins: [monthsMixin],

  data() {
    return {
      modalType: 'add',
      confirmId: null,
      messageContent: '',
      confirmTarget: '',
      bounceMessageListingUrl: adminUrls.bounceMessageUrls.messageListing,
      model: {
        bounceMessage: '',
        bounceMessageType: '',
      },
      count: 0,
      bounceFilterType: '',
      bounceMessageId: '',
      formSubmitted: false,
      bounceMessagesTableColumns: ['message', 'type', 'created_at', 'actions'],
      bounceMessagesTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        headings: {
          message: () =>
            this.$t(
              'frontend_groovemail_admin_bounce_message_settings_bounce_message'
            ),
          type: () =>
            this.$t(
              'frontend_groovemail_admin_bounce_message_settings_bounce_type'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['message'],
        sortable: ['message', 'created_at'],
        customFilters: ['type'],
        requestFunction(data) {
          const requestParams = {
            ...data,
            ascending: data.ascending === 1 ? 'desc' : 'asc',
            search: data.query,
          };
          delete requestParams.byColumn;
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data,
            count: data.total,
          };
        },
      },

      confirmFileTarget: null,
    };
  },

  validations: {
    model: {
      bounceMessage: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(500),
      },
      bounceMessageType: {
        required,
      },
    },
  },

  components: {
    AdminPageShell,
    ServerTable,
  },

  mounted() {
    this.$watch(
      () => this.$refs.serverTable.$refs.bounceMessageSettingsTable.count,
      (value) => {
        this.count = value;
      }
    );
  },

  computed: {
    // Returns true if the modal type is add, otherwise false
    addModal() {
      return this.modalType === 'add';
    },

    /**
     * Returns the title for modal 
     *  @return {string} - the title for modal depeding on modal type
     */ 
    modalTitle() {
      return this.addModal
        ? this.$t('frontend_groovemail_admin_bounce_message_settings_add_new_bounce_message')
        : this.$t('frontend_groovemail_admin_bounce_message_settings_edit_bounce_message');
    },

    /**
     * Returns styling for bounce message button.
     * @return {object} - styling of button.
     */
    bounceMessageButtonViaImport() {
      return {
        '--import-ip-text': this.$t(
          'frontend_groovemail_admin_bounce_message_settings_import_bounce_message'
        ),
      };
    },

    /**
     * Returns bounce types 
     * @return {array} - returns the bounce types - soft, hard, ignored
     */
    getBounceMessageTypes() {
      return [
        {
          id: 1,
          text: this.$t('frontend_groovemail_admin_campaign_soft_bounces'),
          value: 'Soft',
        },
        {
          id: 2,
          text: this.$t('frontend_groovemail_admin_campaign_hard_bounces'),
          value: 'Hard',
        },
        {
          id: 3,
          text: this.$t('frontend_groovemail_admin_bounce_message_settings_ignored_bounce_message'),
          value: 'Ignored',
        },
      ];
    },

    /**	
     * Returns bulk actions options in dropdown
     * @return {array} data to download or delete specific messages
    */
    getBulkOptions() {
      const actions = [
        {
          id: 2,
          name: this.$t('frontend_groovemail_admin_bounce_message_settings_delete_all_soft'),
          callback: () => this.openDeleteFilterUpdatedModal('soft'),
        },
        {
          id: 3,
          name: this.$t('frontend_groovemail_admin_bounce_message_settings_delete_all_hard'),
          callback: () => this.openDeleteFilterUpdatedModal('hard'),
        },
        {
          id: 4,
          name: this.$t('frontend_groovemail_admin_bounce_message_settings_delete_all_ignored'),
          callback: () => this.openDeleteFilterUpdatedModal('ignored'),
        },
        {
          id: 5,
          name: this.$t('frontend_groovemail_admin_bounce_message_settings_delete_all'),
          callback: () => this.openDeleteFilterUpdatedModal('all'),
        },
      ];

      if (this.count) {
        actions.unshift({
          id: 1,
          name: this.$t('frontend_groovemail_download_bounce_message_text'),
          callback: () => this.downloadBounceMessages(),
        });
      }

      return actions;
    },

    /**	
     * Returns slot data for bounce message table.
     * @return {array} details for slot columns for bounce message table.
    */
    bounceMessageTableSlotData() {
      return [
        {
          slotName: 'message',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.message
              ? props.row.message
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'type',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.type
              ? props.row.type
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.editBounceMessageSetting(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_delete'),
              conditions: () => {
                return true;
              },
              callback: (props) =>
                this.openDeleteBounceMessage(props.row.id),
            },
          ],
        },
      ];
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    // Opens bounce message modal
    openBounceMessageModal() {
      this.$root.$emit('modal-open', 'bounce-message-modal');
    },

    // closes bounce message modal
    closeBounceMessageModal() {
      this.$root.$emit('modal-close', 'bounce-message-modal');
    },

    // Clears the data in the bounce message model 
    bounceMessageInitialized() {
      this.model.bounceMessage = '';
      this.model.bounceMessageType = '';
      this.$v.model.bounceMessage.$reset();
      this.$v.model.bounceMessageType.$reset();
      this.formSubmitted = false;
      this.modalType = 'add';
    },

    /**
     * Opens edit bounce message popup. 
     * @param {string} id unique id of a bounce message.
    */
    async editBounceMessageSetting(id) {
      this.formSubmitted = true;
      this.modalType = 'edit';
      this.bounceMessageId = id;
      const bounceMessageData = await getData(`${this.bounceMessageListingUrl}/${id}`);
      this.model.bounceMessage = bounceMessageData?.data?.message;
      this.model.bounceMessageType = bounceMessageData?.data?.type;
      this.openBounceMessageModal();
    },

    // Used to open a modal and add bounce messages 
    async addBounceMessages() {
      this.formSubmitted = true;
      this.$v.model.bounceMessage.$touch();
      this.$v.model.bounceMessageType.$touch();
      if (
        !this.$v.model.bounceMessage.$invalid &&
        !this.$v.model.bounceMessageType.$invalid
      ) {
        postData(this.bounceMessageListingUrl, {
          message: this.model.bounceMessage,
          type: this.model.bounceMessageType,
          status: 1,
        }).then(() => {
          this.$refs.serverTable.$refs.bounceMessageSettingsTable.refresh();
          this.closeBounceMessageModal();
        }).catch(async (error) => {
          await showRequestErrorAlert(this.$t('frontend_groovemail_forms_view_invalid_data') || error?.response?.data?.message);
        });
      }
    },

    // open delete Bounce Message modal
    async openDeleteBounceMessage(id) {
      // set the Confirm id
      this.confirmId = id;

      // open the modal
      this.$refs[`confirmation-delete-bounce-message`].open();
    },

    // close delete Bounce Message modal
    closeDeleteBounceMessage() {
      // reset the Confirm id
      this.confirmId = null;
    },

    // Used to delete a bounce message
    async deleteBounceMessage() {
      try {
        const url = this.bounceMessageListingUrl;
        await deleteData(`${url}/${this.confirmId}`);
        
        const query = this.$refs.serverTable.$refs.bounceMessageSettingsTable.filteredQuery;
        const page = this.$refs.serverTable.$refs.bounceMessageSettingsTable.Page;
        const limit = this.bounceMessagesTableOptions.perPage;
        const ascending = this.$refs.serverTable.$refs.bounceMessageSettingsTable.orderBy.ascending ? 'desc' : 'asc';
        const orderBy = this.$refs.serverTable.$refs.bounceMessageSettingsTable.orderBy.column;
        const search = this.$refs.serverTable.$refs.bounceMessageSettingsTable.query;
        const type = this.bounceFilterType ? this.bounceFilterType : 'all';
        
        const bounceMessageData = await getData(
          `${url}?query=${query}&limit=${limit}&page=${page}&ascending=${ascending}&orderBy=${orderBy}
           &search=${search}&type=${type}`
        );
        this.$refs.serverTable.updateData(
          bounceMessageData?.data?.data,
          bounceMessageData?.data?.total
        );
      } catch (error) {
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Used to update the bounce message opened in the edit modal
    async updateBounceMessages() {
      this.$v.model.bounceMessage.$touch();
      this.$v.model.bounceMessageType.$touch();
      if (
        !this.$v.model.bounceMessage.$invalid &&
        !this.$v.model.bounceMessageType.$invalid
      ) {
        putData(`${this.bounceMessageListingUrl}/${this.bounceMessageId}`, {
          message: this.model.bounceMessage,
          type: this.model.bounceMessageType,
          status: 1,
        }).then(() => {
          this.$refs.serverTable.$refs.bounceMessageSettingsTable.refresh();
          this.closeBounceMessageModal();
        }).catch(async (error) => {
          await showRequestErrorAlert(this.$t('frontend_groovemail_forms_view_invalid_data') || error?.response?.data?.message);
        });
      }
    },

    /**
     * Used to filter the messages on the basis of bounce types
     * @params {object} event - click event that stores the bounce type in value attribute
     */
    bounceFilterUpdated(event) {
      if (event) {
        this.bounceFilterType = event;
        this.$refs.serverTable.$refs.bounceMessageSettingsTable.customQueries.type = event;
      } else {
        this.bounceFilterType = '';
        this.$refs.serverTable.$refs.bounceMessageSettingsTable.customQueries.type = '';
      }
      this.$refs.serverTable.$refs.bounceMessageSettingsTable.refresh();
    },


    // open delete FilterUpdated modal
    async openDeleteFilterUpdatedModal(filterType) {
      this.confirmTarget = filterType;
      this.messageContent = this.getBounceMessageDeleteConfirmationTitle(filterType);

      // open the modal
      this.$refs[`confirmation-delete-filter-updated`].open();
    },

    // Used to get the title for delete FilterUpdated confirmation modal
    getBounceMessageDeleteConfirmationTitle(filterType) {
      let title;
      switch (filterType) {
        case 'soft':
          title = this.$t(
            'frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_all_soft_bounce_message'
          );
          break;
        case 'hard':
          title = this.$t(
            'frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_all_hard_bounce_message'
          );
          break;
        case 'ignored':
          title = this.$t(
            'frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_all_ignored_bounce_message'
          );
          break;
        case 'all':
          title = this.$t(
            'frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_all_bounce_message'
          );
          break;
        default:
          title = this.$t(
            'frontend_groovemail_admin_bounce_message_settings_are_you_sure_delete_bounce_message'
          );
      }
      return title;
    },

    // close delete FilterUpdated modal
    closeDeleteFilterUpdatedModal() {
      // reset the data
      this.confirmTarget = '';
      this.messageContent = '';
    },

    // Used to delete all bounce messages
    async deleteFilterUpdated() {
      deleteData(`/admin/bulk/hardbouncemessage?delete_type=${this.confirmTarget}`)
        .then(() => {
          this.$refs.serverTable.$refs.bounceMessageSettingsTable.refresh();
        })
        .catch(async (error) => {
          await showRequestErrorAlert(this.$t('frontend_groovemail_forms_view_invalid_data') || error?.response?.data?.message);
        });
    },

    // on file change event
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;

      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      const formData = new FormData();
      formData.append('file', this.confirmFileTarget[0]);
      postData(adminUrls.bounceMessageUrls.importBounceMessages, formData)
        .then(() => {
          this.$refs.serverTable.$refs.bounceMessageSettingsTable.refresh();
        })
        .catch(async (error) => {
          await showRequestErrorAlert(this.$t('frontend_groovemail_forms_view_invalid_data') || error?.response?.data?.message);
        });
      
      // Clear the file input
      document.getElementById('upload').value = '';
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },

    // Used to download sample bounce messages
    async downloadSampleForBounceMessage() {
      try {
        await downloadCsvFile(
          adminUrls.bounceMessageUrls.downloadSampleMessages,
          null,
          'sample_bounce_messages.csv'
        );
      } catch (error) {
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    // Used to download all bounce messages  
    async downloadBounceMessages() {
      const exportType = {
        export_type: this.bounceFilterType ? this.bounceFilterType : 'all',
        search: this.$refs.serverTable.$refs.bounceMessageSettingsTable.query,
      };

      try {
        await downloadCsvFile(
          adminUrls.bounceMessageUrls.downloadBounceMessages,
          { params: exportType },
          'sample_bounce_messages.csv'
        );
      } catch (error) {
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },
};
</script>


<style lang="scss">
.groovemail-bounce-message-settings-table #gd-server-table-view {
  .VueTables--server .table-responsive .VueTables__table {
    th:nth-child(1),
    td:nth-child(1) {
      width: 60%;
      word-break: break-word;
    }
  }
}
</style>
